import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_battery_get',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_BATTERY_GET}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/RHHqXtx/ifzero.jpg',
      width: 30,
      height: 30,
      alt: '*'
    }
  ],
  output: 'Number',
  style: 'sensor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_BATTERY_GET_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_battery_get'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_battery_get'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let code = `ifzero.battery()`
  return [code, Blockly.Python.ORDER_ATOMIC]
}
